var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureImportanceOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.80078C2.32843 3.80078 3 3.12921 3 2.30078C3 1.47235 2.32843 0.800781 1.5 0.800781C0.671573 0.800781 0 1.47235 0 2.30078C0 3.12921 0.671573 3.80078 1.5 3.80078Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.30078C2.05228 3.30078 2.5 2.85307 2.5 2.30078C2.5 1.7485 2.05228 1.30078 1.5 1.30078C0.947715 1.30078 0.5 1.7485 0.5 2.30078C0.5 2.85307 0.947715 3.30078 1.5 3.30078Z",
    stroke: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.362 7.1615C5.83807 7.1615 6.224 6.77557 6.224 6.2995C6.224 5.82343 5.83807 5.4375 5.362 5.4375C4.88593 5.4375 4.5 5.82343 4.5 6.2995C4.5 6.77557 4.88593 7.1615 5.362 7.1615Z",
    fill: "#272D55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.362 6.6615C5.56193 6.6615 5.724 6.49943 5.724 6.2995C5.724 6.09957 5.56193 5.9375 5.362 5.9375C5.16207 5.9375 5 6.09957 5 6.2995C5 6.49943 5.16207 6.6615 5.362 6.6615Z",
    stroke: "#272D55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.362 11.1615C5.83807 11.1615 6.224 10.7756 6.224 10.2995C6.224 9.82343 5.83807 9.4375 5.362 9.4375C4.88593 9.4375 4.5 9.82343 4.5 10.2995C4.5 10.7756 4.88593 11.1615 5.362 11.1615Z",
    fill: "#272D55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.362 10.6615C5.56193 10.6615 5.724 10.4994 5.724 10.2995C5.724 10.0996 5.56193 9.9375 5.362 9.9375C5.16207 9.9375 5 10.0996 5 10.2995C5 10.4994 5.16207 10.6615 5.362 10.6615Z",
    stroke: "#272D55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.362 15.1615C5.83807 15.1615 6.224 14.7756 6.224 14.2995C6.224 13.8234 5.83807 13.4375 5.362 13.4375C4.88593 13.4375 4.5 13.8234 4.5 14.2995C4.5 14.7756 4.88593 15.1615 5.362 15.1615Z",
    fill: "#272D55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.362 14.6615C5.56193 14.6615 5.724 14.4994 5.724 14.2995C5.724 14.0996 5.56193 13.9375 5.362 13.9375C5.16207 13.9375 5 14.0996 5 14.2995C5 14.4994 5.16207 14.6615 5.362 14.6615Z",
    stroke: "#272D55"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.30078H18",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.30078H18",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.3008H18",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.3008H18",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureImportanceOperationIcon);
export default __webpack_public_path__ + "static/media/FeatureImportanceOperationIcon.33cdc71e5e12268a778bec175f57af02.svg";
export { ForwardRef as ReactComponent };